var map = {
	"./0_result.jpg": 952,
	"./1_result.jpg": 887,
	"./2_result.jpg": 2887,
	"./3_result.jpg": 7860,
	"./4_result.jpg": 6427,
	"./5_result.jpg": 4208,
	"./6_result.jpg": 1131,
	"./7_result.jpg": 9181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1845;